const DAY_MS = 86_400_000;

function parseDay(value: string): number | null {
	if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return null;
	const time = Date.parse(`${value}T00:00:00Z`);
	return Number.isFinite(time) && new Date(time).toISOString().slice(0, 10) === value ? time : null;
}

function dayWord(days: number) {
	if (days % 100 >= 11 && days % 100 <= 14) return "дней";
	return days % 10 === 1 ? "день" : days % 10 >= 2 && days % 10 <= 4 ? "дня" : "дней";
}

export function analysisPeriodDescription(from: string, to: string, now = new Date(), language: "en" | "ru" = "ru"): { label?: string; exact: string } {
	const start = parseDay(from), end = parseDay(to);
	if (start === null || end === null || start > end) return { exact: `${from} — ${to}` };
	const format = (value: string) => value.split("-").reverse().join(".");
	const exact = from === to ? format(from) : `${format(from)} — ${format(to)}`;
	// Match the dashboard's local calendar dates, using UTC only for day arithmetic
	// so daylight-saving changes cannot add or remove a day from the range.
	const today = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
	const monthStart = Date.UTC(now.getFullYear(), now.getMonth(), 1);
	const previousMonthStart = Date.UTC(now.getFullYear(), now.getMonth() - 1, 1);
	let label: string | undefined;
	if (start === end) {
		if (end === today) label = language === "ru" ? "Сегодня" : "Today";
		else if (end === today - DAY_MS) label = language === "ru" ? "Вчера" : "Yesterday";
		else if (end === today - 2 * DAY_MS) label = language === "ru" ? "Позавчера" : "Day before yesterday";
	} else if (start === monthStart && end === today) label = language === "ru" ? "Этот месяц" : "This month";
	else if (start === previousMonthStart && end === monthStart - DAY_MS) label = language === "ru" ? "Прошлый месяц" : "Last month";
	else if (end === today || end === today - DAY_MS) {
		const days = (end - start) / DAY_MS + 1;
		if (language === "en") label = `Last ${days} ${days === 1 ? "day" : "days"}${end < today ? " through yesterday" : ""}`;
		else {
			const prefix = days % 10 === 1 && days % 100 !== 11 ? "Последний" : "Последние";
			label = `${prefix} ${days} ${dayWord(days)}${end < today ? " по вчерашний день" : ""}`;
		}
	}
	return { label, exact };
}

export function analysisPeriodLabel(from: string, to: string, now = new Date(), language: "en" | "ru" = "ru"): string {
	const { label, exact } = analysisPeriodDescription(from, to, now, language);
	return label ? `${label} (${exact})` : exact;
}
